import PlainHelperText from 'app/common/ui-next/plain-helper-text/plain-helper-text'
import { getScrollToErrorClassName } from 'app/common/hooks/useScrollToError'

import PlainCheckbox from 'app/common/ui-next/plain-checkbox'
import { ChangeEvent, useCallback, useState } from 'react'
import { FormTemplate } from './FormGridTemplate'


export const controls = {
  homeschoolingOnly: 'homeschoolingOnly',
} as const

type Props = {
  homeschoolingOnly: boolean
  disabled?: boolean
  formID: string
  errors: Map<string, string>
  resetErrors: () => void
}

export const AdditionalFormCompensation = ({ homeschoolingOnly, disabled, formID, errors, resetErrors }: Props) => {
  const error = errors.get('homeschoolingOnly')
  const [curValue, setData] = useState<boolean>(homeschoolingOnly)

  const handleSelect = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.currentTarget
    setData(checked)
    resetErrors()
  }, [resetErrors])

  return (
    <>
      <FormTemplate
        title="Дополнительно:"
      >
        <PlainCheckbox
          label="использовать только для учащихся, обучающихся на домашнем обучении"
          name={`${controls.homeschoolingOnly}`}
          value="active"
          checked={curValue}
          onChange={handleSelect}
          disabled={disabled}
          form={formID}
        />
      </FormTemplate>
      <PlainHelperText
        className={getScrollToErrorClassName(!!error)}
        error
      >
        {error}
      </PlainHelperText>
    </>
  )
}

